module.exports = __webpack_public_path__ + "media/bory-video.3e028354.webm";